// extracted by mini-css-extract-plugin
export default {"container":"EM6_iWUWjk11rObFzJPh"};